export enum StatusNotification {
	READ = 1,
	UNREAD = 2
}
